import type { GetStartedStep, Step } from "../../../../types";
import { PaymentSources } from "../constants/payment-sources";
import { StepValues } from "../constants/step-values";
import type {
  PaymentDetails,
  PaymentPlanStep,
  PaymentSource,
  PaymentStep,
  PaymentSteps,
} from "../types";

export function getSteps(
  paymentSource: PaymentSource,
  paymentDetails: PaymentDetails | null,
) {
  const getStartedStep: GetStartedStep = {
    label: "Get started",
    value: StepValues.GET_STARTED,
    component: "GetStartedStep",
    completed_at: null,
    name: "get-started",
    element_config: {
      clientName: `${paymentDetails?.first_name} ${paymentDetails?.last_name}`,
      clientEmail: paymentDetails?.email || "",
    },
  };

  const transactionDetailsStep: Step<undefined> = {
    label: "Transaction details",
    value: StepValues.TRANSACTION_DETAILS,
    component: "TransactionDetailsStep",
    completed_at: null,
    name: StepValues.TRANSACTION_DETAILS,
    is_editable: true,
  };

  const paymentPlanStep: PaymentPlanStep = {
    label: "Payment plan overview",
    value: StepValues.PAYMENT_PLAN_OVERVIEW,
    component: "PaymentPlanStep",
    completed_at: null,
    name: StepValues.PAYMENT_PLAN_OVERVIEW,
  };

  const paymentStep: PaymentStep = {
    label: "Make a payment",
    value: StepValues.PAYMENT,
    component: "PaymentStep",
    completed_at: null,
    name: StepValues.PAYMENT,
  };

  let steps: PaymentSteps = [];

  switch (paymentSource) {
    case PaymentSources.PAY_REQUEST:
      steps = [getStartedStep, paymentStep];
      break;
    case PaymentSources.CHECKOUT:
    case PaymentSources.CUSTOM_CHECKOUT:
      steps = [transactionDetailsStep, paymentStep];
      break;
    case PaymentSources.PAYMENT_PLAN:
      steps = [getStartedStep, paymentPlanStep, paymentStep];
      break;
  }

  return steps;
}
